{
  "button": {
    "back": "Atrás",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "fullscreen_enter": "Pantalla completa",
    "fullscreen_exit": "Salir de pantalla completa",
    "refresh": "Actualizar",
    "toggle_dark": "Modo oscuro",
    "toggle_langs": "Cambiar idiomas",
    "remove": "Eliminar",
    "clear_all": "Limpiar todo",
    "delete": "Borrar",
    "edit": "Editar",
    "buy_now": "Comprar ahora",
    "enter_another_card": "Introduce otra tarjeta",
    "try_again": "Intentar otra vez",
    "enter_another_code": "Introduce otro código",
    "submit_code": "Ingrese el código",
    "download": "Descargar",
    "no": "No",
    "go_to_homepage": "Ir a la página de inicio"
  },
  "common": {
    "loading": "Cargando...",
    "loading_failed": "Carga fallida",
    "empty_search": "No se encontraron resultados con un título \"{searchValue}\".",
    "empty_list": "La lista está vacía.\nVuelve mas tarde.",
    "data-not-found": "No se encontraron datos o el servidor no responde. Vuelva a intentarlo más tarde."
  },
  "not-found": "No se ha encontrado",
  "locales": {
    "en": "English",
    "de": "German",
    "pt": "Portugal",
    "es": "Spanish",
    "uk-UA": "Ukrainian",
    "pl": "Polish",
    "fr": "French",
    "he": "Hebrew",
    "it": "Italian",
    "ko": "Korean",
    "title": "Elija el idioma del sitio web",
    "ca": "Catalan"
  },
  "baseHeader": {
    "menu": {
      "account": "Su cuenta",
      "language": "Idioma: {currentLanguage}",
      "logout": "Cerrar sesión",
      "manage_following": "Administrar seguimiento",
      "select_language": "Seleccione el idioma",
      "selected_videos": "Vídeos seleccionados",
      "my_clips_and_highlights": "Mis clips/destacados"
    }
  },
  "labels": {
    "sign_in": "Iniciar sesión",
    "sign_up": "Inscribirse",
    "continue": "Continuar",
    "email": "Correo electrónico",
    "forgot_password": "Se te olvidó tu contraseña",
    "password": "Clave",
    "date_added": "Fecha añadida:",
    "highlights": "Destacados",
    "latest": "Más reciente",
    "live": "En vivo",
    "password_new": "Nueva contraseña",
    "password_old": "Contraseña anterior",
    "password_repeat": "Repita la contraseña",
    "save": "Guardar",
    "see_all": "Ver todo >",
    "upcoming": "Próximos",
    "update": "Actualizar",
    "country": "País",
    "phone": "Teléfono",
    "search": "Búsqueda",
    "load_more": "Carga más",
    "follow": "Seguir",
    "following": "Siguiendo",
    "total": "Total",
    "all": "Todos",
    "sport_type": "Tipo de deporte",
    "full_name": "Nombre completo",
    "newest": "El más nuevo",
    "oldest": "Más antiguo",
    "modal_labels": {
      "delete_clip": "¿Seguro que quieres eliminar este clip?",
      "delete_highlight": "¿Está seguro de que desea eliminar este destacado?",
      "delete_profile": "¿Está seguro de que desea eliminar su perfil?",
      "delete_tag": "¿Está seguro de que desea eliminar estas etiquetas?\n¿Está seguro de que desea eliminar esta etiqueta?"
    },
    "active": "Activo",
    "submit": "Enviar",
    "purchase": "Compra",
    "confirm_new_password": "Confirmar nueva contraseña",
    "enter_new_password": "Ingrese nueva clave",
    "dark": "Oscuro",
    "light": "Luz",
    "powered_by": "Por",
    "policy": "Política de privacidad",
    "terms": "Términos de servicio",
    "next": "Próximo",
    "search_input_placeholder": "Buscar escuelas, clubes, ligas, etc.",
    "skip": "Saltar",
    "amount": "Monto",
    "date": "Fecha",
    "type": "Tipo",
    "continue_with": "Continuar con {proveedor}",
    "or": "o",
    "anytime": "Cualquier momento",
    "event_date": "Fecha del evento",
    "past_30_days": "últimos 30 días",
    "past_7_days": "últimos 7 días",
    "past_90_days": "últimos 90 días",
    "today": "Hoy",
    "yesterday": "Ayer",
    "all_results": "Todos los resultados",
    "events": "Eventos",
    "views": "sin vistas |\n{contar} ver |\n{contar} vistas",
    "clip": "clip |\nclips",
    "tag": "Etiqueta |\nEtiquetas",
    "game_videos": "Vídeos de juegos",
    "bookmark_add": "Agregar a seleccionado",
    "bookmark_remove": "Quitar de seleccionado",
    "share": "Compartir",
    "days": "Días | \nDía",
    "hours": "Horas | \nHora",
    "minutes": "Minutos | \nMinuto",
    "seconds": "Segundos | \nSegundo",
    "latest_events": "Últimos acontecimientos",
    "latest_highlights": "Últimos momentos destacados",
    "statistics": "Estadísticas",
    "commerce_category_labels": {
      "free": "Gratis",
      "member": "Miembro",
      "ppv": "Paga por ver",
      "subscription": "Suscripción",
      "rental": "Alquiler",
      "premium": "Premium"
    },
    "commerce_category_message": {
      "member": "Por favor inicia sesión para ver el juego",
      "ppv": "Necesitas comprar un boleto PPV para ver este contenido",
      "ppv_subscription": "Necesitas comprar una suscripción/entrada PPV para ver este contenido",
      "subscription": "Necesitas comprar una suscripción para ver este contenido"
    },
    "main": "Principal",
    "game_highlights": "Aspectos destacados del juego",
    "player_highlights": "Lo más destacado del jugador",
    "watch_full_game": "Ver el juego completo",
    "your_clips_highlight": "Tus clips/destacados",
    "create_highlight": "Crear destacados",
    "access_code": "Introduce el código de acceso",
    "ppv_price": "Ver desde {price}",
    "access_time": "Obtendrás acceso a",
    "duration": "Duración: hasta {duration} | Duración: {duration} {units}",
    "full_access": "Acceso completo",
    "limited_access": "Acceso limitado",
    "ppv_tickets": "Boletos PPV",
    "subscriptions": "Suscripciones",
    "release_date": "Fecha de lanzamiento",
    "months": "Meses | \nMes",
    "weeks": "Semanas | \nSemana",
    "years": "Años | \nAño",
    "change_product": "Cambiar producto",
    "go_to_event": "Ir al evento",
    "go_to_account": "Ir a la cuenta",
    "go_to_main_page": "Ir a la página principal",
    "name": "Nombre",
    "update_card": "Tarjeta actualizada",
    "page_not_found": "Página no encontrada",
    "inactive": "Inactivo",
    "my_club": "Mi club",
    "select_your_club": "Seleccione su club",
    "add_to_selected": "Añadir a Seleccionado",
    "remove_from_selected": "Quitar de Seleccionado",
    "password_not_match": "Las contraseñas no coinciden",
    "search_by_sport_type": "Buscar por tipo de deporte",
    "videos": "Vídeos",
    "category": "Categoría"
  },
  "pages": {
    "auth_sign_up": {
      "enter_your_details_below": "Ingrese sus datos a continuación",
      "password_updated_successuly_text": "Su contraseña fue actualizada con éxito",
      "already_have_account": "¿Ya tienes una cuenta?",
      "follow_category_header": "Seleccione las categorías que desea seguir"
    },
    "account": {
      "account_delete_button": "Borrar cuenta",
      "tab_billing_title": "Datos de facturación",
      "tab_devices_title": "Dispositivos",
      "tab_general_title": "General",
      "tab_password_title": "Clave",
      "tab_subscription_title": "Suscripción",
      "account_delete_confirm": "¿Está seguro de que desea eliminar su perfil?",
      "account_delete_description": "Esta acción no se puede revertir.",
      "tab_ppv_access_text": "El boleto PPV da acceso a",
      "tab_ppv_no_ppv": "No tienes boletos de PPV. \n<br/> Vaya a la página del evento para comprar un boleto.",
      "tab_ppv_title": "Boletos PPV",
      "account_delete_successfully": "¡Tu cuenta ha sido eliminada con éxito!",
      "account_update_successfully": "¡Tu cuenta ha sido actualizada con éxito!"
    },
    "auth_password": {
      "forgot_password_help_text": "Te ayudaremos a restablecerlo.",
      "forgot_password_success_text": "Si existe una cuenta para {email}, le enviaremos instrucciones para restablecer su contraseña. ¿No los conseguiste? Verifique la dirección de correo electrónico o solicite volver a enviar las instrucciones",
      "back_to_sign_in": "Volver para iniciar sesión",
      "resend_instruction": "Reenviar la instrucción de nuevo",
      "send_reset_link": "Enviar enlace de reinicio",
      "set_new_password": "Establecer nueva contraseña"
    },
    "clubs": {
      "manage_following": "Administrar seguimiento",
      "empty_page": "Aún no sigues a nadie.",
      "choose_your_club": "Elige tu club",
      "choose_your_club_message": "Elige el club con el que estarás asociado"
    },
    "auth_login": {
      "device_no_longer_allowed_error": "Su dispositivo actual ya no está en la lista de dispositivos permitidos.\nInicie sesión de nuevo.",
      "expired_session_error": "Su sesión ha caducado. \nInicie sesión de nuevo."
    },
    "auth_login_limit": {
      "device_limit_reached": "Límite de dispositivos alcanzado",
      "remove_device_to_login": "Elimina uno para iniciar sesión",
      "current_device": "Dispositivo actual"
    },
    "account_billing": {
      "card_cvv": "CVC / CVV",
      "card_expiry_date": "Fecha de caducidad",
      "card_holder_name": "Nombre en la tarjeta",
      "card_number": "Número de tarjeta",
      "button_back_to_billing_info": "Volver a la información de facturación",
      "payment_history_empty_text": "Tu historial de pagos está vacío",
      "payment_history_title": "Historial de pagos",
      "alert_credit_card_save_success": "La información de su tarjeta de crédito se ha guardado correctamente",
      "alert_credit_card_update_success": "La información de su tarjeta de crédito ha sido actualizada con éxito",
      "label_modal_confirm_credit_card_delete": "Una vez que elimine su tarjeta de crédito, su suscripción también se cancelará. \nEl contenido aún está disponible para usted hasta la fecha de finalización del plan. \n¿Está seguro de que desea eliminar la tarjeta de crédito?",
      "alert_credit_card_delete_success": "Su tarjeta de facturación se ha eliminado correctamente"
    },
    "account_subscription": {
      "active_subscription": "Suscripción activa",
      "button_subscribe_now": "Suscríbase ahora",
      "button_subscription_cancel": "Cancelar suscripción",
      "subscription_due_date": "Fecha de vencimiento",
      "subscription_expiration_date": "Caducado por",
      "subscription_last_payment_date": "Última fecha de pago",
      "subscription_next_charge_date": "Próxima carga",
      "button_back_to_my_subscription": "Volver a mi suscripción",
      "or_select_plan": "o selecciona tu plan",
      "redeem_access_code_label": "Canjea tu código de acceso aquí",
      "alert_access_code_redeem_not_found": "El código de acceso solicitado no existe",
      "alert_access_code_redeemed_success": "Código de acceso canjeado con éxito",
      "alert_subscription_cancel_success": "Suscripción cancelada con éxito",
      "checkbox_apply_as_new_credit_card": "Aplicarle una nueva tarjeta de pago",
      "label_plan_amount": "Monto del plan",
      "label_taxes": "Impuestos",
      "label_total_billed": "Total facturado",
      "tab_all_subscriptions": "Todas las suscripciones",
      "tab_my_subscriptions": "Mis Suscripciones",
      "alert_access_code_redeem_code_used": "Código de acceso solicitado ya utilizado",
      "label_full_access": "Acceso completo",
      "label_full_access_description": "Acceso completo a todo el contenido del sitio web",
      "label_limited_access": "Acceso limitado",
      "label_limited_access_description": "Acceso limitado a todo el contenido del sitio web",
      "subscription_expires": "La suscripción caduca el {date}",
      "payment_details": "{title}: detalles de pago",
      "no_subscriptions_text": "No hay suscripciones activas en la lista.\n\nVuelve más tarde",
      "redeem_access_code_title": "Canjea tu Código de Acceso",
      "button_back_to_my_tickets": "Volver a mis entradas",
      "list_subscriptions_empty": "La lista de suscripciones disponibles está vacía. \nVuelve mas tarde",
      "button_subscription_keep": "Mantener suscripción",
      "cancel_subscription_modal_subtitle": "Su suscripción se cancelará al final de su período de facturación el {date}. \nPuede cambiar de opinión en cualquier momento antes de esta fecha.",
      "cancel_subscription_modal_title": "¿Está seguro de que desea cancelar su suscripción?"
    },
    "videos": {
      "last_viewed": "Visto por última vez",
      "user_interesting": "Tú podrías estar interesado",
      "description_no_items": "Este es el lugar para tus videos favoritos.\n¡Guarda, revisa y comparte!",
      "title_no_items": "Agregar algunos videos a los seleccionados"
    },
    "clips": {
      "title_no_clips": "Aún no tienes ningún clip.\n¡Ve al vídeo y crea tu primer clip!",
      "title_no_highlights": "Aún no tienes ningún destacado.\n¡Ve al vídeo y crea tus primeros destacados!",
      "title_no_items_with_selected_filter": "No se encontraron elementos con este filtro"
    },
    "auth_sign_in": {
      "welcome_message": "Bienvenido de nuevo",
      "new_to": "Nuevo en",
      "auth_terms": "Al continuar, acepta nuestros {terms_of_service} y {privacy_policy}"
    },
    "account_password": {
      "alert_password_update_success": "Tu contraseña ha sido cambiada exitosamente"
    },
    "league": {
      "all_rounds": "Todas las rondas",
      "fields": "Campos"
    },
    "events": {
      "event_start_date": "El evento comenzará el {date}",
      "failed_statistics": "No se pudieron cargar las estadísticas relacionadas con este evento. Vuelva a intentarlo más tarde.",
      "game_video_login_message": "Inicia sesión para ver los videos del juego.",
      "tags_login_message": "Inicie sesión para ver las etiquetas.",
      "modal_share_with_time": "Empezar a las {hora}",
      "modal_share_title": "Comparte este video",
      "tabs": {
        "event_tags": {
          "create_tag": "Crear etiqueta",
          "title_no_tags_not_logged_in": "Todavía no hay etiquetas en la lista, inicie sesión para crear nuevas etiquetas",
          "choose_player_color": "Ingrese un jugador '",
          "choose_tag": "Elija el tipo de etiqueta",
          "make_tag_global": "Hacer etiqueta como global",
          "name_the_tag": "Nombra la etiqueta",
          "tag_creating_successfully_text": "La etiqueta se creó con éxito",
          "title_enabled_tagging": "No hay etiquetas en la lista.",
          "update_tag": "Actualizar etiqueta",
          "tag_updating_successfully_text": "La etiqueta se actualizó correctamente",
          "filters": {
            "by_player_number": "Jugador '",
            "by_type": "Por tipo",
            "clear_all_btn": "Borrar todo |\nBorrar todo ({cuenta}) |\nBorrar todo ({count})",
            "no_tags": "No hay etiquetas que coincidan con el filtro seleccionado",
            "popup_title": "Filtrar",
            "search_input_placeholder": "Buscar etiquetas específicas",
            "show_results_btn": "Mostrar resultados",
            "select_all": "Seleccionar todo | \nSeleccionar todo ({count}) | \nSeleccionar todo ({count})"
          },
          "tag_deleting_successfully_text": "La etiqueta se eliminó con éxito",
          "is_external_content": "Este es contenido externo, no puedes crear una etiqueta",
          "title_no_tags": "Aún no se han creado etiquetas",
          "pause_all_btn": "Pausar todo",
          "play_all_btn": "Jugar todo"
        },
        "event_videos": {
          "create_clip": "Crear vídeo",
          "title_no_clips_not_logged_in": "Todavía no hay clips en la lista, inicie sesión para crear nuevos clips",
          "name_the_clip": "Nombra el clip",
          "clip_creating_successfully_text": "Tu clip pronto estará listo",
          "title_enabled_clipping": "No hay clips en la lista.",
          "title_no_clips": "Aún no se han creado clips"
        }
      },
      "viewing_conditions": "Elige tus condiciones de visualización",
      "appreciation": "¡Gracias!",
      "success_purchased": "Has comprado correctamente {subscription}",
      "failed_purchased_message": "Vuelva a intentarlo o introduzca otra tarjeta.",
      "purchased_declined": "El pago fue rechazado",
      "watching_event_by_text": "Estás viendo este evento por",
      "failed_code_applied_message": "Vuelve a intentarlo o introduce otro código.",
      "failed_code_applied_title": "Codigo invalido",
      "success_code_applied": "Código {title} aplicado con éxito",
      "submit_reedem_code_input_placeholder": "Ingrese su código de acceso aquí",
      "failed_already_used_code": "Este código ya ha sido utilizado",
      "player_errors": {
        "vod_corrupted_files": "¡Ups! \nLos archivos de video se han dañado y no se pueden reproducir",
        "vod_files_not_found": "¡Ups! \nArchivos de video no encontrados",
        "vod_playback_failed": "¡Ups! \nLa reproducción falló durante la transmisión de VOD"
      },
      "event_will_start_in_a_few_min": "El evento comenzará automáticamente en unos minutos..."
    },
    "club": {
      "favorite_club_creating_successfully_text": "Su club fue elegido con éxito"
    }
  },
  "sport_types": {
    "americanFootball": "Fútbol americano",
    "beachvolleyball": "Voleibol playa",
    "fieldhockey": "Hockey sobre hierba",
    "icehockey": "Hockey sobre hielo",
    "rollerhockey": "Hockey sobre patines",
    "badminton": "Bádminton",
    "baseball": "Béisbol",
    "basketball": "Baloncesto",
    "bowling": "Bolos",
    "cricket": "Grillo",
    "floorball": "Floorball",
    "futsal": "Fútbol sala",
    "gymnastics": "Gimnasia",
    "handball": "Balonmano",
    "lacrosse": "Lacrosse",
    "netball": "Baloncesto",
    "other": "Otro",
    "rugby": "Rugby",
    "snooker": "Snooker",
    "soccer": "Fútbol",
    "softball": "Sofbol",
    "swimming": "Natación",
    "tennis": "Tenis",
    "volleyball": "Vóleibol",
    "waterpolo": "Polo acuático",
    "wrestling": "Lucha",
    "football": "Fútbol"
  },
  "baseFooter": {
    "rights": "Reservados todos los derechos"
  },
  "footer_links": {
    "about_us": "Sobre",
    "faq": "Preguntas más frecuentes",
    "privacy_policy": "Privacidad",
    "terms_of_service": "Términos",
    "custom": "{custom}"
  },
  "countries": {
    "AD": "Andorra",
    "AE": "Emiratos Árabes",
    "AF": "Afganistán",
    "AG": "Antigua y Barbuda",
    "AI": "Anguila",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "angola",
    "AR": "Argentina",
    "AS": "Samoa Americana",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AZ": "Azerbaiyán",
    "BA": "Bosnia y Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Bélgica",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Baréin",
    "BI": "Burundi",
    "BJ": "Benín",
    "BM": "Islas Bermudas",
    "BO": "Bolivia",
    "BR": "Brasil",
    "BS": "Bahamas",
    "BT": "Bután",
    "BW": "Botsuana",
    "BY": "Bielorrusia",
    "BZ": "Belice",
    "CA": "Canadá",
    "CF": "República Centroafricana",
    "CG": "Congo",
    "CH": "Suiza",
    "CK": "Islas Cook",
    "CL": "Chile",
    "CM": "Camerún",
    "CN": "Porcelana",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CX": "Isla de Navidad",
    "CY": "Chipre",
    "CZ": "República Checa",
    "DE": "Alemania",
    "DJ": "Yibuti",
    "DK": "Dinamarca",
    "DM": "Dominica",
    "DO": "República Dominicana",
    "DZ": "Argelia",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egipto",
    "ER": "Eritrea",
    "ES": "España",
    "ET": "Etiopía",
    "FI": "Finlandia",
    "FJ": "Fiyi",
    "FK": "Islas Malvinas",
    "FM": "Micronesia",
    "FO": "Islas Faroe",
    "FR": "Francia",
    "GA": "Gabón",
    "GD": "Granada",
    "GE": "Georgia",
    "GF": "Guayana Francesa",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenlandia",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadalupe",
    "GQ": "Guinea Ecuatorial",
    "GR": "Grecia",
    "GS": "Georgia del sur y las islas Sandwich del sur",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bisáu",
    "GY": "Guayana",
    "HN": "Honduras",
    "HR": "Croacia",
    "HT": "Haití",
    "HU": "Hungría",
    "ID": "Indonesia",
    "IE": "Irlanda",
    "IL": "Israel",
    "IN": "India",
    "IO": "Territorio Británico del Océano Índico",
    "IQ": "Irak",
    "IR": "Irán",
    "IS": "Islandia",
    "IT": "Italia",
    "JM": "Jamaica",
    "JO": "Jordán",
    "JP": "Japón",
    "KE": "Kenia",
    "KG": "Kirguistán",
    "KH": "Camboya",
    "KI": "Kiribati",
    "KM": "Comoras",
    "KW": "Kuwait",
    "KY": "Islas Caimán",
    "KZ": "Kazajstán",
    "LB": "Líbano",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesoto",
    "LT": "Lituania",
    "LU": "Luxemburgo",
    "LV": "Letonia",
    "LY": "Libia",
    "MA": "Marruecos",
    "MC": "Mónaco",
    "MD": "Moldavia",
    "ME": "Montenegro",
    "MG": "Madagascar",
    "MH": "Islas Marshall",
    "MK": "Macedonia",
    "ML": "Malí",
    "MM": "Birmania",
    "MN": "Mongolia",
    "MP": "Islas Marianas del Norte",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauricio",
    "MV": "Maldivas",
    "MW": "Malaui",
    "MX": "México",
    "MY": "Malasia",
    "NA": "Namibia",
    "NC": "Nueva Caledonia",
    "NE": "Níger",
    "NF": "Isla Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Países Bajos",
    "NO": "Noruega",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nueva Zelanda",
    "OM": "Omán",
    "PA": "Panamá",
    "PE": "Perú",
    "PF": "Polinesia francés",
    "PG": "Papúa Nueva Guinea",
    "PH": "Filipinas",
    "PK": "Pakistán",
    "PL": "Polonia",
    "PR": "Puerto Rico",
    "PT": "Portugal",
    "PW": "Palaos",
    "PY": "Paraguay",
    "QA": "Katar",
    "RO": "Rumania",
    "RS": "Serbia",
    "RW": "Ruanda",
    "SA": "Arabia Saudita",
    "SB": "Islas Salomón",
    "SC": "Seychelles",
    "SD": "Sudán",
    "SE": "Suecia",
    "SG": "Singapur",
    "SI": "Eslovenia",
    "SK": "Eslovaquia",
    "SL": "Sierra Leona",
    "SM": "San Marino",
    "SN": "Senegal",
    "SV": "El Salvador",
    "SZ": "Suazilandia",
    "TC": "Islas Turcas y Caicos",
    "TD": "Chad",
    "TG": "Para llevar",
    "TH": "Tailandia",
    "TJ": "Tayikistán",
    "TK": "Tokelau",
    "TM": "Turkmenistán",
    "TN": "Túnez",
    "TO": "Tonga",
    "TR": "Pavo",
    "TT": "Trinidad y Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwán",
    "UA": "Ucrania",
    "UG": "Uganda",
    "UY": "Uruguay",
    "UZ": "Uzbekistán",
    "VE": "Venezuela",
    "VU": "Vanuatu",
    "WF": "Wallis y Futuna",
    "WS": "Samoa",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "Sudáfrica",
    "ZM": "Zambia",
    "ZW": "Zimbabue",
    "AN": "Antillas Holandesas",
    "BN": "Brunéi",
    "CC": "Islas Cocos-Keeling",
    "CI": "Costa de Marfil",
    "CV": "Cabo Verde",
    "CW": "Curazao",
    "GE-AB": "Abjasia",
    "HK": "RAE de Hong Kong China",
    "KP": "Corea del Norte",
    "KR": "Corea del Sur",
    "LA": "Laos",
    "MO": "RAE de Macao China",
    "PS": "Territorio Palestino",
    "RE": "Reunión",
    "RU": "Rusia",
    "SH-AC": "Ascensión",
    "SY": "Siria",
    "TL": "Timor Oriental",
    "TZ": "Tanzania",
    "UK": "Reino Unido",
    "US": "Estados Unidos",
    "VG": "Islas Vírgenes Británicas",
    "VI": "Islas Vírgenes de EE.UU",
    "VN": "Vietnam",
    "ZR": "Congo, Dem.\nRep. de (Zaire)"
  },
  "errors": {
    "could_not_find_event": "Lo sentimos, no pudimos encontrar el evento que buscas.",
    "could_not_find_page": "Lo sentimos, no pudimos encontrar la página que está buscando.",
    "could_not_find_team": "Lo sentimos, no pudimos encontrar el equipo que buscas.",
    "event_not_found": "Evento no encontrado",
    "page_not_found": "Página no encontrada",
    "team_not_found": "Equipo no encontrado",
    "could_not_find_results": "Lo sentimos, no pudimos encontrar ningún resultado para esta búsqueda."
  },
  "tags": {
    "baseball_bottom_1st": "abajo 1º",
    "baseball_bottom_2nd": "segundo fondo",
    "baseball_double": "doble",
    "baseball_double_play": "doble jugada",
    "baseball_fly_out": "volar",
    "baseball_ground_out": "molido",
    "baseball_hit": "golpear",
    "baseball_home_run": "carrera",
    "baseball_popout": "ventana emergente",
    "baseball_run": "correr",
    "baseball_single": "soltero",
    "baseball_stolen_base": "bases robadas",
    "baseball_strikeout": "tachar",
    "baseball_substitution": "sustitución",
    "baseball_top_1st": "primero superior",
    "baseball_top_2nd": "segundo superior",
    "baseball_triple_play": "juego triple",
    "baseball_tripple": "triplicar",
    "baseball_walk": "caminar",
    "basketball_alley_oop": "callejón oop",
    "basketball_assist": "asistir",
    "basketball_big_play": "gran jugada",
    "basketball_block": "bloquear",
    "basketball_dunk": "remojar",
    "basketball_momentym": "impulso",
    "basketball_money_time": "tiempo de dinero",
    "basketball_substitution": "sustitución",
    "basketball_three_point": "tres puntos",
    "beach_volleyball_dig": "excavar",
    "beach_volleyball_double": "doble",
    "beach_volleyball_free_ball": "pelota gratis",
    "beach_volleyball_match_point": "punto decisivo",
    "beach_volleyball_mishit": "golpe defectuoso",
    "beach_volleyball_serve": "atender",
    "beach_volleyball_set_point": "punto fijo",
    "beach_volleyball_shank": "caña",
    "beach_volleyball_side_out": "lado afuera",
    "beach_volleyball_spike": "espiga",
    "beach_volleyball_substitution": "sustitución",
    "field_ball_loss": "pérdida de balón",
    "field_ball_possesion": "posesión de pelota",
    "field_circle_penetration": "penetración circular",
    "field_hockey_4v4": "4v4",
    "field_hockey_big_hit": "gran éxito",
    "field_hockey_fight": "luchar",
    "field_hockey_goal": "meta",
    "field_hockey_other": "otro",
    "field_hockey_power_play": "juego de poder",
    "field_hockey_save": "ahorrar",
    "field_hockey_shot": "disparo",
    "field_hockey_substitution": "sustitución",
    "field_interception": "interceptación",
    "field_penalty_corner": "córner corto",
    "field_press_fp_hc": "prensa",
    "field_time_penalty": "penalización de tiempo",
    "field_turn_over": "Rotación",
    "football_big_catch": "gran captura",
    "football_big_hit": "gran éxito",
    "football_big_run": "gran carrera",
    "football_field_goal": "gol de campo",
    "football_kick_return": "retorno de patada",
    "football_kickoff": "patada inicial",
    "football_punt_return": "devolución de despeje",
    "football_substitution": "sustitución",
    "football_touch_down": "aterrizar",
    "futsal_corner_kick": "saque de esquina",
    "futsal_foul": "falta",
    "futsal_free_kick": "Tiro libre",
    "futsal_goal": "meta",
    "futsal_header": "encabezamiento",
    "futsal_penalty": "multa",
    "futsal_redcard": "tarjeta roja",
    "futsal_save": "ahorrar",
    "futsal_shot": "disparo",
    "futsal_shot_on_target": "tiro al blanco",
    "futsal_substitution": "sustitución",
    "futsal_yellowcard": "tarjeta amarilla",
    "general_bad": "malo",
    "general_drill": "perforar",
    "general_good": "bien",
    "gymnastic_wow": "Guau",
    "handball_foul": "falta",
    "handball_goal": "meta",
    "handball_penalty_shot": "lanzamiento de penalti",
    "handball_red_card": "tarjeta roja",
    "handball_save": "ahorrar",
    "handball_shot_on_goal": "tiro al arco",
    "handball_substitution": "sustitución",
    "handball_suspension": "suspensión",
    "handball_yellow_card": "tarjeta amarilla",
    "hockey_4v4": "4v4",
    "hockey_big_hit": "gran éxito",
    "hockey_fight": "luchar",
    "hockey_goal": "meta",
    "hockey_power_play": "juego de poder",
    "hockey_save": "ahorrar",
    "hockey_shot": "disparo",
    "hockey_substitution": "sustitución",
    "lacrosse_clear": "claro",
    "lacrosse_face_off": "enfrentarse",
    "lacrosse_goal": "meta",
    "lacrosse_ground_ball": "bola de tierra",
    "lacrosse_man_up": "ser valiente",
    "lacrosse_penalty": "multa",
    "lacrosse_save": "ahorrar",
    "lacrosse_shot": "disparo",
    "lacrosse_substitution": "sustitución",
    "other_wow": "otro_wow",
    "roller_ball_loss": "pérdida de balón",
    "roller_ball_possesion": "posesión de pelota",
    "roller_circle_penetration": "penetración circular",
    "roller_hockey_4v4": "4v4",
    "roller_hockey_big_hit": "gran éxito",
    "roller_hockey_fight": "luchar",
    "roller_hockey_goal": "meta",
    "roller_hockey_other": "otro",
    "roller_hockey_power_play": "juego de poder",
    "roller_hockey_save": "ahorrar",
    "roller_hockey_shot": "disparo",
    "roller_hockey_substitution": "sustitución",
    "roller_interception": "interceptación",
    "roller_penalty_corner": "esquina",
    "roller_press_fp_hc": "prensa",
    "roller_time_penalty": "penalización de tiempo",
    "roller_turn_over": "Rotación",
    "rugby_break_down": "descomponer",
    "rugby_conversion": "conversión",
    "rugby_drop_goal": "dejar caer la meta",
    "rugby_garry_owen": "garry owen",
    "rugby_grubber": "él de suciedad",
    "rugby_knock_on": "tocar",
    "rugby_maul": "mazo",
    "rugby_penalty_try": "intento de penalti",
    "rugby_substitution": "sustitución",
    "soccer_corner_kick": "saque de esquina",
    "soccer_foul": "falta",
    "soccer_free_kick": "Tiro libre",
    "soccer_goal": "meta",
    "soccer_header": "encabezamiento",
    "soccer_penalty": "multa",
    "soccer_redcard": "tarjeta roja",
    "soccer_save": "ahorrar",
    "soccer_shot": "disparo",
    "soccer_shot_on_target": "tiro al blanco",
    "soccer_substitution": "sustitución",
    "soccer_yellowcard": "tarjeta amarilla",
    "volleyball_dig": "excavar",
    "volleyball_double": "doble",
    "volleyball_free_ball": "pelota gratis",
    "volleyball_match_point": "punto decisivo",
    "volleyball_mishit": "golpe defectuoso",
    "volleyball_serve": "atender",
    "volleyball_set_point": "punto fijo",
    "volleyball_shank": "caña",
    "volleyball_side_out": "lado afuera",
    "volleyball_spike": "espiga",
    "volleyball_substitution": "sustitución",
    "wrestling_wow": "Guau"
  }
}
